import { PureComponent, ReactNode } from 'react';
import { deleteDb } from '../store/idbHandler';
import { resetTracking } from '../tracking';
import { GO_TO_LOGOUT, INIT } from '../routes/paths';
import { clearLocalStorage } from '../store/localstorage';

class FlushAndSetup extends PureComponent {
    componentDidMount = async (): Promise<void> => {
        try {
            await deleteDb();

            resetTracking();

            clearLocalStorage();

            if (new URLSearchParams(window.location.search).get('logout') === 'true') {
                window.location.replace(GO_TO_LOGOUT);
                return;
            }
            window.location.replace(INIT);
        } catch (error) {
            console.error(error);
            alert('Failed: ' + (error as Error).message);
        }
    };

    render(): ReactNode {
        return (
            <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
                <div className="pulse">
                    <svg width="16px" height="12px">
                        <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                    </svg>
                </div>
                <p className="text-24 text-neutral-black">Re-Setting up workspace...</p>
            </div>
        );
    }
}

export default FlushAndSetup;
